import { getViewportCanvasToVirtual, getViewportDesignToVirtual, getViewportVirtualToCanvas, getViewportVirtualToDesign, } from '@printu/viewport';
export const covertPointFromWorkspaceToVirtual = (viewport, point, workspace) => {
    switch (workspace) {
        case 'canvas':
            return getViewportCanvasToVirtual(viewport, point);
        case 'design':
            return getViewportDesignToVirtual(viewport, point);
        default:
            return point;
    }
};
export const covertPointFromVirtualToWorkspace = (viewport, point, workspace) => {
    switch (workspace) {
        case 'canvas':
            return getViewportVirtualToCanvas(viewport, point);
        case 'design':
            return getViewportVirtualToDesign(viewport, point);
        default:
            return point;
    }
};
